<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">
      <span v-if="!complete">Disable Diode</span>
      <span v-else>Delete Diode</span>
    </div>
    <div>
      <p v-if="!complete">
        Are you sure you wish to disable diode <span class="has-text-primary">{{serial}}</span>?
        The diode will be totally unusable until it is recommissioned.
      </p>
      <template v-else>
        <p>
          Are you sure you wish to permanently delete diode <span class="has-text-primary">{{serial}}</span>?
          The diode <em>cannot</em> be recommissioned.
        </p>
        <p class="mt-3">
          Enter "Delete" to confirm then click yes to delete.
          <input class="input mt-3" type="text" v-model="confirm">
        </p>
      </template>
      <p v-if="errors.diode" class="help is-danger pt-2">{{errors.diode}}</p>
      <div class="pt-5">
        <button :disabled="complete && confirm !== 'Delete'" class="button is-primary mr-5" @click.prevent="submit">
          Yes
        </button>
        <button class="button is-default" @click="$emit('complete')">No</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';


export default {
  name: 'delete-diode-form',
  data () {
    return {
      data: {},
      confirm: '',
      errors: {}
    };
  },
  props: ['serial', 'complete'],
  methods: {
    async submit() {
      try {
        await api.admin.diodes.remove(this.serial, this.complete);
        this.errors = {};
        this.data = {};
        this.confirm = '';
        this.$emit('complete');
      } catch (error) {
        this.handle();
      }
    },
    handle() {
      this.errors = {};
      this.errors.diode = 'There was an error deleting this diode.';
    }
  }
};
</script>
